<mat-card>
  <mat-card-content>
    <mat-card-subtitle>RCS Account Payments</mat-card-subtitle>
    <p>Process the RCS account payment on the card machine and then capture the payment here...</p>
    <button mat-button (click)="payAccount('RCS-ACCOUNT')">Pay RCS Account</button>
  </mat-card-content>
</mat-card>

<mat-card style="margin-top: 16px;">
  <mat-card-subtitle>Store RCS Account Transactions</mat-card-subtitle>
  <kendo-grid [kendoGridBinding]="transactions" [scrollable]="true" [resizable]="true" [reorderable]="true"
    [sortable]="true">

    <kendo-grid-column [width]="75" title="" class="td-action">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <button matTooltip="Generate Payment Receipt" *ngIf="dataItem.canCreateReceipt" mat-icon-button
          (click)="generateDocument(dataItem)">
          <mat-icon>post_add</mat-icon>
        </button>
        <button matTooltip="Download Payment Receipt Document" *ngIf="dataItem.canDownloadReceipt" mat-icon-button
          (click)="downloadResource(dataItem.resource)">
          <mat-icon>download</mat-icon>
        </button>
        <!-- <button matTooltip="Email Payment Receipt Document" *ngIf="dataItem.canDownloadReceipt" mat-icon-button
          (click)="emailDocument(dataItem.email)">
          <mat-icon>forward_to_inbox</mat-icon>
        </button> -->
        <button style="margin-left: 16px;" matTooltip="Undo RCS Account Payment" *ngIf="dataItem.canReversePayment"
          mat-icon-button (click)="reversePayment(dataItem)">
          <mat-icon>undo</mat-icon>
        </button>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="150" field="creationDate" title="Created At">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.creationDate | date: 'MMM d, yyyy HH:mm'}}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="100" field="createdBy" title="Created By">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipse">{{dataItem.createdBy}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="120" field="transactionType" title="Transaction Type">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipse">
          {{dataItem.transactionType}}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="130" format="{0:n2}" class="td-number" field="transactionAmount"
      title="Transaction Amount">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="td-number">{{dataItem.transactionAmount | number:'1.2-2'}}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="100" field="storeName" title="Branch">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipse">{{dataItem.storeName}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="100" field="container" title="Container">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipse">{{dataItem.container}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [width]="100" field="cardNumber" title="Card">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipse">{{dataItem.cardNumber}}</span>
      </ng-template>
    </kendo-grid-column>

    <!-- <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showEmailDetails">
      <div style="margin: 16px;">
        <kendo-grid [kendoGridBinding]="dataItem.emails" [scrollable]="true" [resizable]="true" [reorderable]="true"
          [sortable]="true">

          <kendo-grid-column [width]="150" field="emailType" title="Email. Type"> </kendo-grid-column>
          <kendo-grid-column [width]="200" field="sentAt" title="Sent At">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{dataItem.sentAt | date: 'MMM d, yyyy HH:mm'}}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="250" field="sentTo" title="Sent To"> </kendo-grid-column>
          <kendo-grid-column [width]="200" field="emailStatus" title="Email Status"> </kendo-grid-column>

        </kendo-grid>
      </div>
    </ng-template> -->

  </kendo-grid>
</mat-card>
